import React from 'react';
import { Field, FieldProps } from 'react-final-form';
import Box from '@material-ui/core/Box';
import FormLabel from '@material-ui/core/FormLabel';
import ToggleOptionsButtons from 'components/buttons/ToggleOptions';

const ToggleOptions = ({
  className,
  name,
  options,
  multi,
  ...rest
}: {
  className?: string;
  name: string;
  options: Array<{ value: any; label: string }>;
  multi?: boolean;
} & FieldProps<any, any>) => (
  <Field
    {...rest}
    name={name}
    render={({ input: { value, onChange }, meta: { touched, error } }) => (
      <Box className={className}>
        <ToggleOptionsButtons
          value={value}
          options={options}
          multi={multi}
          error={touched && error}
          onChange={onChange}
        />
        {touched && error && <FormLabel error>{error}</FormLabel>}
      </Box>
    )}
  />
);

export default ToggleOptions;
